import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getMultipleChoiceMultipleAnswer = (params) => {
	var url = ApiRouters.MULTIPLECHOICEMULTIPLEANSWER;
	return api.get(url, { params });
};

export const getMultipleChoiceMultipleAnswerDetail = (id, params) => {
	var url = `${ApiRouters.MULTIPLECHOICEMULTIPLEANSWER}/${id}`;
	return api.get(url, { params });
};

export const createQuesMultipleChoiceMultipleAnswer = (body) => {
	var url = ApiRouters.MULTIPLECHOICEMULTIPLEANSWER;
	return api.post(url, body);
};

export const updateMultipleChoiceMultipleAnswerDetail = (body) => {
	var url = `${ApiRouters.MULTIPLECHOICEMULTIPLEANSWER}/${body.id}`;
	return api.put(url, body.model);
};

export const deleteMultipleChoiceMultipleAnswer = (id) => {
	var url = `${ApiRouters.MULTIPLECHOICEMULTIPLEANSWER}/${id}`;
	return api.delete(url);
};
